<mbs-modal [title]="'shared:modals.addDestinationBucket.detectIssues' | i18next"
           [isCustomModal]="true"
           #modal>
  <ng-container modal-body>
    <div>{{ 'shared:modals.addDestinationBucket.extensionsDescription' | i18next }}</div>

    <ul class="mt-2 mb-0 p-0 ml-4">
      <li *ngFor="let extension of extensions">{{ extension }}</li>
    </ul>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button [type]="'primary'"
                (click)="modal.save(true)">
      {{ 'shared:buttons.editDestination' | i18next }}
    </mbs-button>

    <mbs-button [type]="'secondary'"
                (click)="modal.close()">
      {{ 'shared:buttons.ignore' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
